const Auth = {
  Login: '/login',
  Verify: '/verify',
  Signup: '/sign-up',
  SelectVerify: '/select-verify',
  ForgotPassword: '/forgot-password',
};

const Dashboard = {
  Home: '/dashboard',
};

const ContactUs = {
  Home: '/contact-us',
};

const Profile = {
  Home: '/profile',
};

const AdditionalInfo = {
  Home: '/additional-info',
};

const Resources = {
  Home: '/resources',
};

const Course = {
  Form: '/forms/:id',
  Vaccine: '/vaccine',
  Completed: '/completed',
  Resource: '/resources/:id',
};

const FamilyInformation = {
  Edit: ':id',
  Create: 'create',
  Home: '/family-information',
};

export const Routes = {
  Auth,
  Course,
  Profile,
  Home: '/',
  Dashboard,
  ContactUs,
  Resources,
  AdditionalInfo,
  NotFound: '/404',
  FamilyInformation,
};
